/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstTransportTypeUpdateBase } from './MstTransportTypeUpdateBase';
import {
    MstTransportTypeUpdateBaseFromJSON,
    MstTransportTypeUpdateBaseFromJSONTyped,
    MstTransportTypeUpdateBaseToJSON,
    MstTransportTypeUpdateBaseToJSONTyped,
} from './MstTransportTypeUpdateBase';

/**
 * 
 * @export
 * @interface MstTransportTypeUpdate
 */
export interface MstTransportTypeUpdate {
    /**
     * 
     * @type {Array<MstTransportTypeUpdateBase>}
     * @memberof MstTransportTypeUpdate
     */
    body: Array<MstTransportTypeUpdateBase>;
}

/**
 * Check if a given object implements the MstTransportTypeUpdate interface.
 */
export function instanceOfMstTransportTypeUpdate(value: object): value is MstTransportTypeUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstTransportTypeUpdateFromJSON(json: any): MstTransportTypeUpdate {
    return MstTransportTypeUpdateFromJSONTyped(json, false);
}

export function MstTransportTypeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstTransportTypeUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstTransportTypeUpdateBaseFromJSON)),
    };
}

export function MstTransportTypeUpdateToJSON(json: any): MstTransportTypeUpdate {
    return MstTransportTypeUpdateToJSONTyped(json, false);
}

export function MstTransportTypeUpdateToJSONTyped(value?: MstTransportTypeUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstTransportTypeUpdateBaseToJSON)),
    };
}

